

export const IS_MADE_FLOW = 'is_made_flow';